import { render, staticRenderFns } from "./Zones.page.vue?vue&type=template&id=2d400261&scoped=true"
import script from "./Zones.page.vue?vue&type=script&setup=true&lang=ts"
export * from "./Zones.page.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Zones.page.vue?vue&type=style&index=0&id=2d400261&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d400261",
  null
  
)

export default component.exports